<template>
  <div class="file-upload-view container view">
    <FileComponent v-model="value" multiple @input="$ev => (value = $ev)" />
    <div class="file-upload-view__items">
      <div class="file-upload-view__item" v-for="item in value" :key="item.url">
        <div>
          <b>{{ item.name }}</b>
          <p>{{ item.url }}</p>
        </div>
        <CopyToClipboard :value="item.url" />
      </div>
    </div>
  </div>
</template>

<script>
import { FileComponent } from '@kvass/file'
import CopyToClipboard from '@/components/CopyToClipboard'

export default {
  data() {
    return {
      value: [],
    }
  },
  components: {
    FileComponent,
    CopyToClipboard,
  },
}
</script>

<style lang="scss">
.file-upload-view {
  min-height: auto;
  display: flex;
  gap: 2rem;

  .kvass-file {
    flex-direction: column-reverse;
    flex-grow: 2;
    max-width: 50vw;
  }
  .kvass-file__thumbnails {
    display: none;
  }
  .kvass-file__droparea {
    min-height: 400px;
    margin: 0;
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex-grow: 1;
    border-radius: var(--border-radius);

    &:empty {
      background-color: rgba(black, 0.03);
    }
  }

  &__item {
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
    padding: 1rem 1rem 1rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    width: 100%;

    p {
      margin: 0;
    }
  }
}
</style>
